import React, { createRef } from 'react';

class Multiselect extends React.Component {
  constructor(props) {
    super(props);
    
    // Convertir initialValues a formato interno si es necesario
    const initialValues = Array.isArray(props.initialValues) 
      ? props.initialValues.map(item => 
          typeof item === 'object' && item.value ? item.value : item)
      : [];
    
    this.state = {
      isOpen: false,
      searchTerm: '',
      selectedValues: initialValues
    };
    
    this.multiSelectRef = React.createRef();
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    // Si el selector se acaba de abrir, enfoca el campo de búsqueda
    if (!prevState.isOpen && this.state.isOpen && this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }

    // Si las selecciones cambiaron, notifica al componente padre
    if (prevState.selectedValues !== this.state.selectedValues) {
      // Aquí convertimos los valores seleccionados a objetos completos para el callback
      const selectedItems = this.state.selectedValues.map(value => 
        this.props.options.find(option => option.value === value) || { value, label: value }
      );
      this.props.onChange(selectedItems, this.state.selectedValues);
    }
  }

  handleClickOutside = (event) => {
    if (this.multiSelectRef.current && !this.multiSelectRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  toggleDropdown = (e) => {
    e.stopPropagation();
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      searchTerm: '' // Limpia el término de búsqueda al abrir/cerrar
    }));
  }

  handleOptionClick = (value) => {
    this.setState(prevState => {
      let newValues;
      if (prevState.selectedValues.includes(value)) {
        newValues = prevState.selectedValues.filter(val => val !== value);
      } else {
        newValues = [...prevState.selectedValues, value];
      }
      return { 
        selectedValues: newValues,
        searchTerm: '' // Limpia la barra de búsqueda al seleccionar un elemento
      };
    });
  }

  removeValue = (e, value) => {
    e.stopPropagation();
    this.setState(prevState => ({
      selectedValues: prevState.selectedValues.filter(val => val !== value)
    }));
  }

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  }

  getFilteredOptions = () => {
    const { options } = this.props;
    const { searchTerm } = this.state;
    
    return options.filter(option => 
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  getSelectedLabels = () => {
    const { options } = this.props;
    const { selectedValues } = this.state;
    
    // Crear un mapa para búsqueda rápida
    const optionMap = {};
    options.forEach(option => {
      optionMap[option.value] = option.label;
    });
    
    // Convertir valores a etiquetas
    return selectedValues.map(value => ({
      value,
      label: optionMap[value] || value.toString()
    }));
  }

  render() {
    const { isOpen, selectedValues, searchTerm } = this.state;
    const { placeholder = 'Seleccionar destinatario' } = this.props;
    const filteredOptions = this.getFilteredOptions();
    const selectedItems = this.getSelectedLabels();
    const hasValues = selectedValues.length > 0;

    return (
      <div 
        className={`multi-select ${hasValues ? 'has-value' : ''}`} 
        ref={this.multiSelectRef}
        name="multiselect"
      >
        <div className="multi-select__selected" onClick={this.toggleDropdown}>
          <span className="multi-select__label">{placeholder}</span>
          
          {selectedItems.map((item) => (
            <span className="pill" key={item.value}>
              {item.label} 
              <span 
                className="pill__remove" 
                onClick={(e) => this.removeValue(e, item.value)}
              >
                &times;
              </span>
            </span>
          ))}
          
          <span className="multi-select__arrow">
            <span className="material-symbols-outlined">keyboard_arrow_down</span>
          </span>
        </div>

        <div className={`multi-select__dropdown ${isOpen ? 'open' : ''}`}>
          {isOpen && (
            <>
              <input 
                type="search" 
                className="multi-select__search" 
                placeholder="Buscar..." 
                value={searchTerm}
                onChange={this.handleSearchChange}
                ref={this.searchInputRef}
                onClick={(e) => e.stopPropagation()}
              />
              <div className="multi-select__options">
                {filteredOptions.map((option) => (
                  <div 
                    className={`multi-select__option ${selectedValues.includes(option.value) ? 'checked' : ''}`}
                    key={option.value}
                    onClick={() => this.handleOptionClick(option.value)}
                  >
                    {option.label}
                  </div>
                ))}
                {filteredOptions.length === 0 && (
                  <div className="multi-select__no-results">No se encontraron resultados</div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Multiselect;
